exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-screens-post-js": () => import("./../../../src/screens/post.js" /* webpackChunkName: "component---src-screens-post-js" */),
  "component---src-templates-front-js": () => import("./../../../src/templates/front.js" /* webpackChunkName: "component---src-templates-front-js" */),
  "component---src-templates-posts-js": () => import("./../../../src/templates/posts.js" /* webpackChunkName: "component---src-templates-posts-js" */)
}

